/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import {
    fork, call, put, select, takeLatest,
} from 'redux-saga/effects';
import mbpLogger from 'mbp-logger';

import mbpUtil from 'mbp-api-util';
import { activePaymentMethod, inActivePaymentMethod } from '../../../../../Checkout/ducks/Payment/Payment-Actions';

import {
    checkApplePayEnabled,
} from './ApplePay-Actions';
import { getBrandConfig } from '../../../App/App-Selectors';

const checkApplePayAvailable = (merchantIdentifier) => new Promise((resolve) => {
    const promise = window.ApplePaySession.canMakePaymentsWithActiveCard(merchantIdentifier);
    promise.then(resolve).catch(() => resolve(false));
});

export function* workerApplePayAvailable() {
    mbpLogger.logDebug({
        appName: process.env.npm_package_name,
        module: 'mbp-checkout',
        function: 'workerApplePayAvailable',
        message: 'initiate apple pay availability check',
    });
    try {
        const brand = yield select(getBrandConfig);
        const merchantIdentifier = mbpUtil.getEnv('APP_APPLE_PAY_MID') || `${brand['apple-pay-merchant-id']}`;
        const applePayEnabled = yield call(
            checkApplePayAvailable,
            merchantIdentifier,
        );
        if (applePayEnabled) {
            yield put(activePaymentMethod('ApplePay'));
        } else {
            yield put(inActivePaymentMethod('ApplePay'));
        }
    } catch (ex) {
        yield put(inActivePaymentMethod('ApplePay'));
        mbpLogger.logError({
            function: 'workerApplePayAvailable',
            appName: process.env.npm_package_name,
            module: 'mbp-checkout',
            jsError: ex,
            message: 'workerApplePayAvailable failed',
        });
    }
}

function* watchCheckApplePayAvailability() {
    yield takeLatest(checkApplePayEnabled().type, workerApplePayAvailable);
}

const watchers = [
    fork(watchCheckApplePayAvailability),
];

export {
    watchers,
};

export default {};
